import ims from '../../../../../imports';
import device from './device';
import netloss_events from './netloss_events';

// STATE - default
let initialState = {
  dealerSiteDevices: null,
  dealerSiteZonesDeviceId: null,
  statusGetDealerSiteDevices: '',
};

// STATE - INIT
const state = JSON.parse(JSON.stringify(initialState));

// GETTERS
const getters = {
  dealerSiteDevices: function (state) {
    return state.dealerSiteDevices ?? {};
  },
  dealerSiteZonesDeviceId: function (state) {
    return state.dealerSiteZonesDeviceId ?? {};
  },
  dealerSiteDeviceOfZone: function (state, getters) {
    return function (zone) {
      const deviceId = getters.dealerSiteZonesDeviceId[zone];
      if (!deviceId) return null;
      const device = getters.dealerSiteDevices[deviceId];
      return device;
    };
  },
  statusGetDealerSiteDevices: function (state) {
    return state.statusGetDealerSiteDevices;
  },
};

// ACTIONS
const actions = {
  getDealerSiteDevices: async function (
    { commit, getters },
    { dealerId, siteId, fields }
  ) {
    if (!ims.auth0_auth.isAuthenticated) return;
    if (getters.statusGetDealerSiteDevices === 'requested') return;
    commit('GET_DEALER_SITE_DEVICES_REQUEST');
    console.debug('GET_DEALER_SITE_DEVICES_REQUEST');
    try {
      const res = await ims.models.getDealerSiteDevices({
        dealerId,
        siteId,
        fields,
      });
      commit('GET_DEALER_SITE_DEVICES_SUCCESS', res.data);
      console.debug('GET_DEALER_SITE_DEVICES_SUCCESS');
      return res.data;
    } catch (err) {
      commit('GET_DEALER_SITE_DEVICES_FAILURE');
      console.debug('GET_DEALER_SITE_DEVICES_FAILURE', err);
      throw err;
    }
  },
};

// MUTATIONS
const mutations = {
  RESET_STATE: function (state) {
    for (let f in state) {
      state[f] = initialState[f];
    }
  },
  GET_DEALER_SITE_DEVICES_REQUEST: function (state) {
    state.statusGetDealerSiteDevices = 'requested';
  },
  GET_DEALER_SITE_DEVICES_SUCCESS: function (state, data) {
    if (!state.dealerSiteDevices) state.dealerSiteDevices = {};
    if (!state.dealerSiteZonesDeviceId) state.dealerSiteZonesDeviceId = {};
    data.forEach((v) => {
      // UPDATE - dealerSiteDevices
      state.dealerSiteDevices[v.device_id] = {
        ...v,
        videoai_area_filter_meta: ims.tool.parseJSON(
          v.videoai_area_filter_meta
        ),
      };
      // UPDATE - dealerSiteZonesDeviceId
      if (!v.zone_number) return;
      const zones = String(v.zone_number).split(',');
      zones.forEach((zone) => {
        state.dealerSiteZonesDeviceId[zone] = v.device_id;
      });
    });
    state.statusGetDealerSiteDevices = 'successful';
  },
  GET_DEALER_SITE_DEVICES_FAILURE: function (state) {
    state.statusGetDealerSiteDevices = 'failed';
  },
};

export default {
  ...device,
  ...netloss_events,
  dealerSiteDevices: {
    state,
    getters,
    actions,
    mutations,
  },
};

// e.g.
// [
//   {
//     "device_id": "173991",
//     "site_id": 34019,
//     "mac": "E43022236E47",
//     "channel": 0,
//     "mac_in_use": "E43022236E47",
//     "onvif_video_source_token": "VideoSourceToken-0",
//     "serial_number": "ZNKC6V4N900010N",
//     "type": 12,
//     "name": "upside",
//     "model": "PND-A9081RV",
//     "private_ip": "192.168.1.15",
//     "private_subnet_mask": null,
//     "private_gateway": null,
//     "public_ip": "222.108.102.14",
//     "mqtt_url": "mqtt://10.1.158.189",
//     "mount_type": 1,
//     "stream_url": "",
//     "video_stream_url": null,
//     "video_stream_info_cache": "{\"deviceChannel\":0,\"ipAddress\":\"192.168.1.15\",\"macAddress\":\"E43022236E47\",\"onvifVideoSourceToken\":\"VideoSourceToken-0\",\"port\":\"80\",\"snapshotStreamURL\":\"rtsp://admin:P%40ssword@192.168.1.15:554/0/onvif/profile2/media.smp\",\"updatedAt\":\"2023-03-02T08:11:26.016519805Z\",\"videoStreamURL\":\"rtsp://admin:P%40ssword@192.168.1.15:554/0/onvif/profile1/media.smp\"}",
//     "firmware_version": "1.41.03_20200724_R418",
//     "firmware_update_status": 0,
//     "timezone": "Seoul",
//     "alarm_zone": "901A",
//     "trouble_zone": null,
//     "virtual_zone": null,
//     "linked_devices": null,
//     "position_metadata": "{\"isShown\":false,\"x\":30,\"y\":30,\"angleOfView\":100,\"angle\":135,\"distance\":50}",
//     "sensors_meta": null,
//     "status_code": 200,
//     "api_version": null,
//     "is_online": 1,
//     "is_online_update_time": "2023-03-02T08:13:18.000Z",
//     "is_online_source": 0,
//     "online_timestamp": 1677744798,
//     "offline_timestamp": 1677744505,
//     "last_access_timestamp": 1677852926,
//     "is_activated": 1,
//     "is_registered": 1,
//     "registered_time": "2023-02-06T09:48:51.000Z",
//     "is_cont_recording": 1,
//     "is_enable_firmware_auto_update": 0,
//     "is_privacy": 0,
//     "privacy_disabled_timestamp": null,
//     "privacy_background_image_url": null,
//     "entry_delay": 60,
//     "exit_delay": 60,
//     "bell_duration": 300,
//     "arming_type": 1,
//     "arming_state": "active",
//     "arming_timestamp": null,
//     "di_state": "none",
//     "di_timestamp": null,
//     "is_event_enabled": 1,
//     "is_live_enabled": 1,
//     "is_speaker_enabled": 0,
//     "speaker_volume": 80,
//     "dl_enable": 0,
//     "cron_job": null,
//     "auto_ip_search_enable": 0,
//     "api_type": "ONVIF",
//     "api_port": 80,
//     "voltage_preset_id": 0,
//     "is_time_sync_enabled": 0,
//     "is_event_video_enabled": 1,
//     "is_onvif_event_enabled": 1,
//     "is_timelapse_enabled": 0,
//     "zone_number": "901A",
//     "is_main_device": 0,
//     "recording_interval_seconds": 20,
//     "arming_type_updated_at": null,
//     "arming_mode_updated_at": null,
//     "camera_type": 9,
//     "auto_resolution_enabled": 1,
//     "videoai_provider_id": 1,
//     "videoai_enabled": 1,
//     "updated_at": "2023-03-03T14:15:26.000Z",
//     "created": "2023-02-06T09:48:51.000Z",
//     "group_channel": 0,
//     "group_id": "173083",
//     "privacy_disabled_duration": "0",
//     "sensors": null,
//     "sensor_count": 0,
//     "relay_count": 0,
//     "event_plan_count": 3000,
//     "is_playback_enabled": 1,
//     "is_vpn_enabled": 0,
//     "network_manager_secret_key": null,
//     "has_live_video_permission": true,
//     "snapshot_url": "https://api.chektdev.com:443/api/v1/snapshots/E43022236E47/0?access_token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzZXJ2aWNlLmNoZWt0LmNvbSIsInN1YiI6IkU0MzAyMjIzNkU0NyIsImF1ZCI6InNlcnZpY2UuY2hla3QuY29tIiwiZXhwIjoxNjc3ODU5ODk0LCJpYXQiOjE2Nzc4NTYyODQsImNoYW5uZWwiOjAsImdyb3VwX2NoYW5uZWwiOjAsImdyb3VwX21hYyI6IkU0NUYwMUI3OTk5NSIsInVzZXJfaWQiOjMsInNpdGVfaWQiOjM0MDE5LCJkZXZpY2VfaWQiOiIxNzM5OTEiLCJpc19wcml2YWN5IjowLCJuYW1lc3BhY2UiOiJkZWFsZXIiLCJzZXJ2aWNlX25hbWUiOiJkZWFsZXIiLCJpcCI6IjEwLjEuMTU4LjE4OSIsImp0aSI6ImE0Nzc4Yzc1LWY4MDQtNGMzOS04Y2RmLTgyMTQyMTg0MzYyZiJ9.dgV_cToRZVCcOEgM6ntpUKvDz0hca-GmKfvKXByrhYM"
//   },
//   {
//     "device_id": "173083",
//     "site_id": 34019,
//     "mac": "E45F01B79995",
//     "channel": 0,
//     "mac_in_use": null,
//     "onvif_video_source_token": null,
//     "serial_number": null,
//     "type": 11,
//     "name": "Stella testing - rtsp",
//     "model": "CKB308",
//     "private_ip": "192.168.1.2",
//     "private_subnet_mask": "255.255.255.0",
//     "private_gateway": "192.168.1.1",
//     "public_ip": "222.108.102.14",
//     "mqtt_url": "mqtt://10.1.158.189",
//     "mount_type": 0,
//     "stream_url": null,
//     "video_stream_url": null,
//     "video_stream_info_cache": null,
//     "firmware_version": "{\"bridge\":\"3.7.0.8.dev\",\"analytics\":\"\"}",
//     "firmware_update_status": 0,
//     "timezone": "Seoul",
//     "alarm_zone": null,
//     "trouble_zone": null,
//     "virtual_zone": "901",
//     "linked_devices": null,
//     "position_metadata": null,
//     "sensors_meta": null,
//     "status_code": null,
//     "api_version": null,
//     "is_online": 1,
//     "is_online_update_time": "2023-03-03T15:10:03.000Z",
//     "is_online_source": 1,
//     "online_timestamp": 1677856203,
//     "offline_timestamp": 1677744505,
//     "last_access_timestamp": 1677852926,
//     "is_activated": 1,
//     "is_registered": 1,
//     "registered_time": "2023-02-01T06:31:30.000Z",
//     "is_cont_recording": 1,
//     "is_enable_firmware_auto_update": 0,
//     "is_privacy": 0,
//     "privacy_disabled_timestamp": null,
//     "privacy_background_image_url": null,
//     "entry_delay": 60,
//     "exit_delay": 60,
//     "bell_duration": 300,
//     "arming_type": 1,
//     "arming_state": "active",
//     "arming_timestamp": 1677668100,
//     "di_state": "none",
//     "di_timestamp": null,
//     "is_event_enabled": 1,
//     "is_live_enabled": 1,
//     "is_speaker_enabled": 0,
//     "speaker_volume": 100,
//     "dl_enable": 0,
//     "cron_job": null,
//     "auto_ip_search_enable": 1,
//     "api_type": "ONVIF",
//     "api_port": 80,
//     "voltage_preset_id": 0,
//     "is_time_sync_enabled": 0,
//     "is_event_video_enabled": 1,
//     "is_onvif_event_enabled": 0,
//     "is_timelapse_enabled": 0,
//     "zone_number": "901",
//     "is_main_device": 0,
//     "recording_interval_seconds": 20,
//     "arming_type_updated_at": null,
//     "arming_mode_updated_at": "2023-02-27T01:42:18.000Z",
//     "camera_type": 0,
//     "auto_resolution_enabled": 1,
//     "videoai_provider_id": null,
//     "videoai_enabled": 0,
//     "updated_at": "2023-03-03T15:10:03.000Z",
//     "created": "2023-02-01T06:31:30.000Z",
//     "group_channel": null,
//     "group_id": null,
//     "privacy_disabled_duration": "0",
//     "sensors": "[{\"enable\":false,\"name\":\"\",\"trigger_type\":\"no\",\"detection_type\":\"level\",\"channels\":[0],\"zone_type\":2,\"event_code\":{\"enable\":true,\"is_used\":false,\"active_code\":\"E130\",\"inactive_code\":\"R130\",\"event_enabled\":true,\"restore_enabled\":false,\"event_url_enabled\":true,\"restore_url_enabled\":true}},{\"enable\":true,\"name\":\"\",\"trigger_type\":\"nc\",\"detection_type\":\"level\",\"channels\":[1],\"zone_type\":2,\"event_code\":{\"enable\":true,\"is_used\":false,\"active_code\":\"E130\",\"inactive_code\":\"R130\",\"event_enabled\":true,\"restore_enabled\":false,\"event_url_enabled\":true,\"restore_url_enabled\":true}},{\"enable\":true,\"name\":\"\",\"trigger_type\":\"nc\",\"detection_type\":\"level\",\"channels\":[2],\"zone_type\":2,\"event_code\":{\"enable\":true,\"is_used\":false,\"active_code\":\"E130\",\"inactive_code\":\"R130\",\"event_enabled\":true,\"restore_enabled\":false,\"event_url_enabled\":true,\"restore_url_enabled\":true}},{\"enable\":true,\"name\":\"\",\"trigger_type\":\"nc\",\"detection_type\":\"level\",\"channels\":[3],\"zone_type\":2,\"event_code\":{\"enable\":true,\"is_used\":false,\"active_code\":\"E130\",\"inactive_code\":\"R130\",\"event_enabled\":true,\"restore_enabled\":false,\"event_url_enabled\":true,\"restore_url_enabled\":true}},{\"enable\":true,\"name\":\"\",\"trigger_type\":\"nc\",\"detection_type\":\"level\",\"channels\":[4],\"zone_type\":2,\"event_code\":{\"enable\":true,\"is_used\":false,\"active_code\":\"E130\",\"inactive_code\":\"R130\",\"event_enabled\":true,\"restore_enabled\":false,\"event_url_enabled\":true,\"restore_url_enabled\":true}},{\"enable\":true,\"name\":\"\",\"trigger_type\":\"nc\",\"detection_type\":\"level\",\"channels\":[5],\"zone_type\":2,\"event_code\":{\"enable\":true,\"is_used\":false,\"active_code\":\"E130\",\"inactive_code\":\"R130\",\"event_enabled\":true,\"restore_enabled\":false,\"event_url_enabled\":true,\"restore_url_enabled\":true}},{\"enable\":true,\"name\":\"\",\"trigger_type\":\"nc\",\"detection_type\":\"level\",\"channels\":[6],\"zone_type\":2,\"event_code\":{\"enable\":true,\"is_used\":false,\"active_code\":\"E130\",\"inactive_code\":\"R130\",\"event_enabled\":true,\"restore_enabled\":false,\"event_url_enabled\":true,\"restore_url_enabled\":true}},{\"enable\":true,\"name\":\"\",\"trigger_type\":\"nc\",\"detection_type\":\"level\",\"channels\":[7],\"zone_type\":2,\"event_code\":{\"enable\":true,\"is_used\":false,\"active_code\":\"E130\",\"inactive_code\":\"R130\",\"event_enabled\":true,\"restore_enabled\":false,\"event_url_enabled\":true,\"restore_url_enabled\":true}},{\"enable\":true,\"name\":\"\",\"trigger_type\":\"no\",\"detection_type\":\"level\",\"channels\":[],\"zone_type\":3,\"event_code\":{\"enable\":true,\"is_used\":false,\"active_code\":\"E401\",\"inactive_code\":\"R401\",\"event_enabled\":true,\"restore_enabled\":false,\"event_url_enabled\":true,\"restore_url_enabled\":true}}]",
//     "sensor_count": 9,
//     "relay_count": 1,
//     "event_plan_count": 3000,
//     "is_playback_enabled": 1,
//     "is_vpn_enabled": 0,
//     "network_manager_secret_key": "GLA1W4T2",
//     "relays": [
//       {
//         "id": "26596",
//         "device_id": "173083",
//         "channel": 0,
//         "enabled": 0,
//         "show_monitoring_enabled": 0,
//         "shows_end_user_app": 1,
//         "camera_id": null,
//         "name": null,
//         "label_type": "default",
//         "default_normal_label": "normal",
//         "default_energized_label": "energized",
//         "manual_normal_label": null,
//         "manual_energized_label": null,
//         "normal_icon": "power_settings_new",
//         "energized_icon": "power_settings_new",
//         "latch_enabled": 1,
//         "momentary_enabled": 0,
//         "timer_enabled": 0,
//         "momentary_delay_times": 0,
//         "timer_delay_times": 0,
//         "last_control_info": null,
//         "position": null,
//         "auto_energized_enabled": 0,
//         "auto_energized_action_type": 0,
//         "created": "2023-02-01T06:31:30.000Z"
//       }
//     ],
//     "audios": [],
//     "snapshot_url": null
//   }
// ]
